import {
  getDiscriminatorField, formatDateDict, addViewErrorHandler, msToMinutes, minutesToMs
} from '../helpers';
import _ from 'lodash';

let initPublisher = (nga) => {
    let createAction = '<ma-create-button ng-if="::entity.creationView().enabled" entry="::entry" entity="::entity" default-values="{publisher_id:entry.values.publisher_id}" size="xs"></ma-create-button>'
    let publishers = nga.entity('publisher');
    publishers.label('Publishers');
    let parentField = nga.field('parent_id', 'reference').targetEntity(nga.entity('publisher'))
        .targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {return {name__icontains: search}}});

    publishers.showView().title('Publisher').fields([
      nga.field('name'),
      nga.field('timezone', 'timezone'),
      nga.field('attribution_rank', 'number').attributes({placeholder: 'Used in someindex'}),
      nga.field('domain_list').transform((value) => value ? (_.isString(value) ? value.split(/, ?/) : value) : null ),
      nga.field('logo_url'),
      nga.field('attribution_country_ids', 'countries'),
      parentField,
      nga.field('disabled_at', 'bool_timestamp').label('Disabled').map(value => value ? value / 1000 : null)
        .transform(value => value ? value * 1000 : null),
      nga.field('streams', 'referenced_list').targetEntity(nga.entity('stream')).targetReferenceField('publisher_id')
        .targetFields([nga.field('id'), nga.field('_name'), getDiscriminatorField(nga)])
        .listActions(['edit', createAction]),
      nga.field('children', 'referenced_list').targetEntity(nga.entity('publisher')).targetReferenceField('parent_id')
        .targetFields([nga.field('id'), nga.field('name')]),
    ])
    return publishers;
}

let initStream = (nga) => {
    const stream = nga.entity('stream');

    const discriminatorField = getDiscriminatorField(nga);
    const readonlyDiscriminatorField = getDiscriminatorField(nga);
    const categoryTypesField = nga.field('category_types', 'reference_many').targetEntity(
        nga.entity('references_stream_category').identifier(nga.field('code'))
      ).targetField(nga.field('name')).validation({required: true});
    const languageField = nga.field('language_ids', 'reference_many').targetEntity(
        nga.entity('references_language').identifier(nga.field('code'))
      ).targetField(nga.field('name')).validation({required: true});
    const publisherField = nga.field('publisher_id', 'reference').label('Publisher')
          .targetEntity(nga.entity('publisher')).targetField(nga.field('name')).remoteComplete(true, {searchQuery: (search) => {
            return {name__icontains: search}}});
    const disabledField = nga.field('disabled_at', 'bool_timestamp').label('Disabled').map(
      value => value ? value / 1000 : null)
      .transform(value => value ? value * 1000 : null);
    const nameField = nga.field('_name').label('New Name').validation({required: true})
    const eidField = nga.field('eid').cssClasses((entity) => (
      entity.values.discriminator != 1 && entity.values.discriminator != 2 && entity.values.discriminator != 6) ? 'hidden' : '');
    const urlField = nga.field('url').cssClasses((entity) => entity.values.discriminator != 5 ? 'hidden' : '');
    const tokenPolicyField = nga.field('acquisition.token_policy_id', 'reference').label('Token Policy').targetEntity(nga.entity('policy_token'))
        .targetField(nga.field('name')).permanentFilters({name__ne: "Canonical URLs"}).defaultValue(1);
    let subscriptionField = nga.field('subscription_id', 'reference').label('Subscription').targetEntity(nga.entity('subscription'))
        .targetField(nga.field('name'));
    stream.label('Streams');
    stream.showView().title('Stream').fields([
      nga.field('id').isDetailLink(true),
      nga.field('_name', 'string').label('Name'),
      publisherField,
      nga.field('logo_url'),
      nga.field('disabled_at', 'unixtime').label('Manually disabled').map((value) => value ? value / 1000 : null),
      discriminatorField,
     ]);
    return stream;
}


let initStoryBlacklist = (nga) => {
    let entity = nga.entity('story_blacklist').label('Story blacklist').identifier(nga.field('story_id'));
    entity.listView().title('Story list').fields([
      nga.field('story_id').isDetailLink(true),
     ]).actions(['filter']).sortField('')

    return entity;
}


export {
  initStream, initPublisher, initStoryBlacklist
}



// WEBPACK FOOTER //
// ./client/app/entities/content.js